"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURE_FLAGS = exports.FEATURE_FLAG = void 0;
exports.FEATURE_FLAG = {
    AI_ORIENTATION_DESCRIPTION: 'AI_ORIENTATION_DESCRIPTION',
    BILLING_INVOICES: 'BILLING_INVOICES',
    FACILITY_SHIFT_BONUS: 'FACILITY_SHIFT_BONUS',
    FACILITY_SPECIALTY_NOTIFICATIONS: 'FACILITY_SPECIALTY_NOTIFICATIONS',
    HELP_SUPPORT_PAGE: 'HELP_SUPPORT_PAGE',
    I9_FORM_ENABLED: 'I9_FORM_ENABLED',
    NOTIFICATION_PREFERENCES: 'NOTIFICATION_PREFERENCES',
    ORIENTATION_OPPORTUNITY_MESSAGING: 'ORIENTATION_OPPORTUNITY_MESSAGING',
    ORIENTATION_PARTIAL_MATCHES: 'ORIENTATION_PARTIAL_MATCHES',
};
exports.FEATURE_FLAGS = Object.values(exports.FEATURE_FLAG);
//# sourceMappingURL=feature-flags.js.map